var React = require('react');

function Jo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-117.8 0h682.6v512h-682.6z"}))),React.createElement("g",{"clipPath":"url(#a)","transform":"translate(110.5) scale(.9375)","key":1},React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"d":"M-117.8 0h1024v170.7h-1024z","key":0}),React.createElement("path",{"fill":"#fff","d":"M-117.8 170.7h1024v170.6h-1024z","key":1}),React.createElement("path",{"fill":"#090","d":"M-117.8 341.3h1024V512h-1024z","key":2}),React.createElement("path",{"fill":"red","d":"M-117.8 512l512-256-512-256v512z","key":3}),React.createElement("path",{"fill":"#fff","d":"M24.5 289l5.7-24.9H4.7l23-11-15.9-19.9 23 11 5.6-24.8 5.7 24.9L69 233.2l-16 19.9 23 11H50.6l5.7 24.9-15.9-20z","key":4})]))]);
}

Jo.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Jo;

Jo.default = Jo;
